<template>
	<div class="bg-white bordert paddingt20 tg-seckill" v-show="showStatus">
		<a :href="data.clickUrl" data-scp="fsmr1.00" :data-bk="data.bk" class="flex-container paddingh20 paddingt10 paddingb10">
			<div class="flex-container left center" style="line-height: normal;">
				<!--<em class="icon-hot text-red text-center fs-20" style="float: left;"></em>-->
				<span class="text-bolder text-red fs-16 lh-1">
					<img :src="data.imageUrl" alt="" style="width:70px;"/>
				</span>
				<span v-text="text" v-if="theme!='three'" class="marginr10 text-dark marginl20"></span>
				<span v-if="(endTime || startTime) > serverTime" class="flex-container center">
					<span :class="timeBg" class="text-white border-radius text-center" v-show="day!=='00'" style="padding:3px;font-size:9px;" v-text="day"></span><span v-show="day!=='00'">&nbsp;天&nbsp;</span>
					<span :class="timeBg" class="text-white border-radius text-center" style="padding:3px;font-size:9px;" v-text="hour"></span>&nbsp;:&nbsp;
					<span :class="timeBg" class="text-white border-radius text-center" style="padding:3px;font-size:9px;" v-text="minute"></span>&nbsp;:&nbsp;
					<span :class="timeBg" class="text-white border-radius text-center" style="padding:3px;font-size:9px;" v-text="second"></span>
				</span>
				<span class="marginl10 text-light fs-12" v-if="theme=='three'&&toStart">后开始</span>
			</div>
			<div class="text-right lh-16">
				<!-- theme不为three的样式 -->
				<div class="flex-container top" v-if="theme!=='three'">
					<span class="fs-12 text-red marginr10" style="vertical-align: top;">更多</span><i class="icon-roundrightfill text-red text-center fs-16"></i>
				</div>
				<!-- theme为three的样式 -->
				<div class="flex-container" v-else>
					<span class="fs-13 text-light" style="vertical-align: top;">更多</span>
					<i class="icon-right text-light fs-11"></i>
				</div>
			</div>
		</a>
		<div>
			<!-- 此处为滚动商品列表 -->
			<cmui-scrollbox :items="items.length<8?items:tempItem" :col="4" v-if="theme==='small'">
				<div>
					<cmui-scrollbox-item v-for="item in items">
						<div class="secKill_item margint20 marginl20">
							<a :href="item.clickUrl" @click="goItem($event)" :data-scp="'fspro1.'+$index" :data-bk="item.bk">
								<div class="ratio-container" :class="toStart?'secKill_item_toStart':''">
									<img :src="item.imageUrl" onerror="this.src='//image1.51tiangou.com/tgou2/img/bg-load.png!s'" alt=""/>
								</div>
								<!--<div class="secKill_item_title text-black text-fixed2 fs-12 margint10" v-text="item.title"></div>-->
								<div class="secKill_item_price text-center">
									<span class="price fs-14 text-red" v-text="'¥'+item.price"></span>
								</div>
								<div class="secKill_item_price text-center lh-1">
									<del class="originalPrice fs-10 text-dark" v-if="item.originalPrice>item.price" v-text="'¥'+item.originalPrice"></del>
								</div>
							</a>
						</div>
					</cmui-scrollbox-item>
					<cmui-scrollbox-item v-if="items.length>=8">
						<div class="secKill_item margint20 marginl20">
							<a :href="data.clickUrl" data-scp="fspromr0.00" :data-bk="data.bk">
								<div class="flex-container center" style="width: 2.23333333rem;height: 2.23333333rem;border: 1px solid #e0e0e0;">
									<div class=" padding10">
										<div class="text-green fs-12 paddingb10" style="border-bottom: 1px solid #e0e0e0;width: 1.5rem;text-align: center;">查看全部</div>
										<div class="text-light fs-12 paddingt10" style="width: 1.5rem;text-align: center;">See more</div>
									</div>
								</div>
							</a>
						</div>
					</cmui-scrollbox-item>
				</div>
			</cmui-scrollbox>
			<cmui-scrollbox :items="items" :col="1.3" v-if="theme==='big'">
				<cmui-scrollbox-item v-for="item in items">
					<div class="secKill_item secKill_item-big marginv20 marginl20 paddingr10 border-radius" v-if="theme==='big'" style="background-color: #f3f4f8">
						<a :href="item.clickUrl" @click="goItem($event)" :data-scp="'fspro1.'+$index" :data-bk="item.bk">
							<div class="pos-r overflow-h">
								<div class="ratio-container float-left marginr20">
									<img :src="item.imageUrl" onerror="this.src='//image1.51tiangou.com/tgou2/img/bg-load.png!s'" alt=""/>
								</div>
								<div class="secKill_item_title text-black text-fixed1 fs-11 margint20" v-text="item.title"></div>
								<div class="secKill_item_title text-black text-fixed1 fs-11" v-text="item.subTitle"></div>
								<div class="secKill_item_price">
									<span class="price fs-14 text-red" v-text="'¥'+item.price"></span>
								</div>
								<span class="originalPrice fs-10 text-light" v-text="item.discount+'折'" v-show="item.discount"></span>
								<div class="badge badge-pill badge-reverse badge-black" v-text="toStart?'即将开始':'立即抢'"></div>
							</div>
						</a>
					</div>
				</cmui-scrollbox-item>
			</cmui-scrollbox>
			<div class="padding20 scroll-container" v-if="theme==='three'">
					<a :href="item.clickUrl" @click="goItem($event)" :data-scp="'fspro1.'+$index" :data-bk="item.bk" style="width:90px" v-for="item in items" class="marginr20">
						<div class="ratio-container img-container border">
							<img :src="item.imageUrl" onerror="this.src='//image1.51tiangou.com/tgou2/img/bg-load.png!s'" alt=""/>
						</div>
						<p class="text-center margint20">
							<span class="text-red marginr10 fs-13" v-text="'¥'+item.price"></span>
							<span class="text-delete fs-10" v-show="item.price!==item.originalPrice" v-text="'¥'+item.originalPrice"></span>
						</p>
						<!-- <span :class="item.soldOut?'black':(toStart?'black':'red')" class="btn block small" style="font-size:12px;line-height:18px;" v-text="item.soldOut?'已售完':(toStart?'即将开始':'立即抢购')">
						</span> -->
					</a>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: String
		, data: {
			type: Object
			, default: {}
		}
		, scpMore: {
			type: String
			, default: ''
		}
		, theme: {
			type: String
			, default: 'small'
		}
	}
	, data: function(){
		var data = {
			items: this.data.items
			, tempItem: this.data.items ? new Array( this.data.items.length +1 ) :[]	// 临时数组，比 items 长度多 1，用于在 theme 为 small 时显示，额外显示 查看全部 标签
			, startTime: this.data.startTime
			, toStart: this.data.toStart || !('endTime' in this.data)
			, serverTime: this.data.serverTime
		};

		if( 'endTime' in this.data ){
			data.endTime = this.data.endTime;
		}
		if( 'startTime' in this.data ){
			data.startTime = this.data.startTime;
		}

		return data;
	}
	, methods: {
		goItem: function(e){
			if( this.toStart ){
				e.preventDefault();
				e.stopPropagation();
			}
		}
	}
	, ready: function(){
		this.$set('timer', setInterval(() =>{
			if( (this.endTime || this.startTime) > this.serverTime ){
				this.serverTime += 1000;
				// 倒计时结束
				if(this.day==0&&this.hour==0&&this.minute==0&&this.second==0){
					this.$dispatch('secKillTimeEnd',this)
				}
			}
			else{
				this.timer && clearInterval( this.timer );
				this.timer = null;
			}
		}, 1000));
	}
	, watch: {
		data: function(newData){
			this.$set('items', newData.items);
			this.$set('tempItem', newData.items ? new Array( newData.items.length +1 ) : []);
			newData.endTime && this.$set('endTime', newData.endTime);
			newData.startTime && this.$set('startTime', newData.startTime);
			this.$set('serverTime', newData.serverTime);
			this.$set('toStart', newData.toStart || !('endTime' in newData));

			this.timer && clearInterval( this.timer );

			this.$set('timer', setInterval(() =>{
				if( (this.endTime || this.startTime) > this.serverTime ){
					this.serverTime += 1000;
					// 倒计时结束
					if(this.day==0&&this.hour==0&&this.minute==0&&this.second==0){
						this.$dispatch('secKillTimeEnd',this)
					}
				}
				else{
					this.timer && clearInterval( this.timer );
					this.timer = null;
				}
			}, 1000));
		}
	}
	, computed: {
		showStatus: function(){
			return (!!this.endTime || !!this.startTime) && this.items.length>3;
		}
		, text: function(){
			var rs = '本档已结束'
				;

			if( 'endTime' in this ){
				if(  this.endTime > this.serverTime ){
					rs = '距结束';
				}
			}
			else if( 'startTime' in this ){
				rs = '距开始';
			}

			return rs;
		}
		, day: function(){
			var date
				, rs = '00'
				;

			if( 'endTime' in this ){
				date = this.endTime;
			}
			else if( 'startTime' in this ){
				date = this.startTime;
			}
			if( date ){
				rs = Math.floor( (date - this.serverTime) / 86400000 );

				rs = rs > 9 ? rs : '0'+ rs;
			}
			return rs;
		}
		, hour: function(){
			var date
				, rs = '00'
				;

			if( 'endTime' in this ){
				date = this.endTime;

			}
			else if( 'startTime' in this ){
				date = this.startTime;
			}

			if( date ){
				rs = Math.floor( (date - this.serverTime) / 3600000 );
				rs = rs % 24;

				rs = rs > 9 ? rs : '0'+ rs;
			}

			return rs;
		}
		, minute: function(){
			var date
				, rs = '00'
				;

			if( 'endTime' in this ){
				date = this.endTime;
			}
			else if( 'startTime' in this ){
				date = this.startTime;
			}

			if( date ){
				rs = Math.floor( (date - this.serverTime) / 60000 );
				rs = rs % 60;

				rs = rs > 9 ? rs : '0'+ rs;
			}

			return rs;
		}
		, second: function(){
			var date
				, rs = '00'
				;

			if( 'endTime' in this ){
				date = this.endTime;
			}
			else if( 'startTime' in this ){
				date = this.startTime;
			}

			if( date ){
				rs = Math.floor( (date - this.serverTime) / 1000 );
				rs = rs % 60;

				rs = rs > 9 ? rs : '0'+ rs;
			}
			return rs;
		}
		, timeBg:function(){
			if(this.theme!=="three"){
				return 'bg-black'
			}else{
				if(this.endTime&&this.endTime>this.serverTime){
					return  'bg-red'
				}else if(this.startTime>this.serverTime){
					return 'bg-black'
				}
			}
		}
		, isStart:function(){
			if(this.endTime&&this.endTime>this.serverTime){
				return  true
			}else if(this.startTime>this.serverTime){
				return false
			}else{
				if(/test\.66buy\.com\.cn/.test(document.location.href)){
					console.log('当前秒杀数据错误，请检查');
					console.log('当前服务器时间为:'+this.serverTime+','+new Date(this.serverTime));
					console.log('当前开始时间为:'+this.startTime+','+new Date(this.startTime));
					console.log('当前结束时间为:'+this.endTime+','+new Date(this.endTime));

				}
				return false//数据错误
			}
		}

	}
};
</script>

<style lang="scss">
.tg-secKill .cmui-scrollbox{
	overflow-y: hidden;
}
.secKill_item .ratio-container{
	position: relative;
}
.secKill_item_toStart:after{
	position: absolute;
	bottom: 5px;
	right: 5px;
	height: 30px;
	width: 30px;
	padding: 3px;
	background: url("//image1.51tiangou.com/tgou2/img2/chengshihui/secKill_item_toStart.png") no-repeat;
	-webkit-background-size: 30px;
	background-size: 30px;
	color: #fff;
	font-size: 10px;
	line-height: 1;
	text-align: center;
	vertical-align: middle;
	content: '即将开始';
}
.secKill_item-big{
	overflow: hidden;
}
.secKill_item-big .ratio-container{
	width: 1.966666rem;
}
.secKill_item-big .badge-pill.badge-reverse{
	position: absolute;
	bottom: 0.266666666rem;
	right: 0.2rem;
	background: transparent;
}
.secKill_item-big .secKill_item_price{
	line-height: 1em;
}
.bg-gray{
	background: #f2f2f2;
}
</style>